import React from 'react';
import { Radio } from 'antd';
import styles from './index.module.css';

export type AccordionItem = {
  id: string;
  icon: React.ReactNode;
  title: string;
  description?: string;
  body: React.ReactNode;
};

type Props = {
  items: AccordionItem[];
  openId: string;
  onOpen: (id: string) => void;
};

// Single-open accordion: exactly one panel is expanded at a time and the
// radio reflects which option is currently selected. Used by the variant
// install step to let the user toggle between the Chrome extension and the
// Javascript snippet.
const Accordion: React.FC<Props> = ({ items, openId, onOpen }) => (
  <div className={styles.accordion}>
    {items.map(item => {
      const isOpen = item.id === openId;

      return (
        <div
          key={item.id}
          className={`${styles.accordionItem} ${
            isOpen ? styles.accordionItemOpen : ''
          }`}
        >
          <button
            type="button"
            className={styles.accordionHeader}
            onClick={() => onOpen(item.id)}
            aria-expanded={isOpen}
          >
            <span className={styles.accordionHeaderLeft}>
              <span className={styles.accordionIcon}>{item.icon}</span>
              <span className={styles.accordionTitleGroup}>
                <span className={styles.accordionTitle}>{item.title}</span>
                {item.description && (
                  <span className={styles.accordionDescription}>
                    {item.description}
                  </span>
                )}
              </span>
            </span>
            <Radio checked={isOpen} className={styles.accordionRadio} />
          </button>

          {/* grid-template-rows transition gives a smooth expand/collapse */}
          <div className={styles.accordionBodyWrap}>
            <div className={styles.accordionBodyInner}>
              <div className={styles.accordionDivider} />
              <div className={styles.accordionBody}>{item.body}</div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default Accordion;
